import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
import { FlashMode } from 'expo-camera'

interface PropsFlash extends Props {
  type: FlashMode
}

export const FlashIcon = (props: PropsFlash) => {
  if (props.type === 'on') {
    return (
      <Svg viewBox='0 0 60 60' fill='none' {...props}>
        <Path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.1623 6.85498C14.9876 4.26138 17.3964 2.5 20.1181 2.5H32.939C37.426 2.5 40.4512 7.08782 38.6837 11.212L34.9175 20H45.6012C51.2205 20 53.9855 26.838 49.945 30.7437L23.5764 56.2335C20.6332 59.0785 15.9108 55.8225 17.5232 52.06L24.8347 35H13.7545C9.52444 35 6.51612 30.886 7.79869 26.855L14.1623 6.85498ZM20.1181 7.5C19.5738 7.5 19.092 7.85228 18.9269 8.371L12.5633 28.371C12.3068 29.1773 12.9085 30 13.7545 30H27.8677C30.0215 30 31.4735 32.2022 30.6252 34.1817L24.564 48.3245L46.47 27.1487C47.278 26.3675 46.725 25 45.6012 25H31.8842C29.7305 25 28.2785 22.7979 29.127 20.8183L34.088 9.2424C34.4415 8.41757 33.8365 7.5 32.939 7.5H20.1181Z'
          fill='#ffffff'
        />
      </Svg>
    )
  }

  return (
    <Svg viewBox='0 0 60 60' fill='none' {...props}>
      <Path
        d='M18.2008 10.6533L14.2226 6.67505C15.1 4.18025 17.4598 2.5 20.1181 2.5H32.939C37.426 2.5 40.4512 7.08782 38.6837 11.212L34.9175 20H45.6012C51.2205 20 53.9855 26.838 49.9452 30.7437L44.0195 36.472L40.4832 32.9358L46.47 27.1487C47.278 26.3675 46.725 25 45.6012 25H32.5475L28.944 21.3964C28.9842 21.203 29.0447 21.0096 29.127 20.8183L34.088 9.2424C34.4415 8.41757 33.8365 7.5 32.939 7.5H20.1181C19.5738 7.5 19.092 7.85228 18.9269 8.371L18.2008 10.6533Z'
        fill='#ffffff'
      />
      <Path
        d='M32.9015 40.265L36.4375 43.801L23.5764 56.2335C20.6332 59.0785 15.9108 55.8225 17.5232 52.06L24.8347 35H13.7545C9.52444 35 6.51612 30.886 7.79869 26.855L10.6211 17.9846L14.6016 21.9651L12.5633 28.371C12.3068 29.1772 12.9085 30 13.7545 30H22.6365L29.4832 36.8465L24.564 48.3245L32.9015 40.265Z'
        fill='#ffffff'
      />
      <Path
        d='M5.01973 5.01966C4.04343 5.99596 4.04343 7.57888 5.01973 8.55518L51.4655 55.001C52.4418 55.9773 54.0248 55.9773 55.001 55.001C55.9775 54.0248 55.9775 52.4418 55.001 51.4655L8.55526 5.01966C7.57896 4.04333 5.99603 4.04333 5.01973 5.01966Z'
        fill='#ffffff'
      />
    </Svg>
  )
}
